import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCaseNormal';
/** Renders an SVG icon. */
const SvgCaseNormal = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M23.407 11.945q2.084 0 3.338 1.169Q28 14.257 28 16.122v8.43q0 .25-.251.25h-1.907q-.252 0-.252-.25v-.72q0-.05-.05-.05-.024-.025-.075.024Q24.335 25 22.328 25q-1.632 0-2.786-.87-1.155-.895-1.155-2.86 0-2.04 1.33-3.084 1.356-1.069 3.665-1.069h2.108q.1 0 .1-.1v-.695q0-1.07-.577-1.691-.552-.622-1.606-.622-.828 0-1.38.423-.528.398-.653 1.094-.026.223-.276.223l-2.058-.124a.3.3 0 0 1-.176-.05.17.17 0 0 1-.05-.174q.15-1.54 1.405-2.486 1.28-.97 3.188-.97m-.552 11.016q1.104 0 1.907-.622.828-.622.828-1.666v-1.591q0-.1-.1-.1h-1.932q-1.23 0-1.983.547-.728.547-.728 1.592 0 .92.552 1.392.552.448 1.456.448m-8.605 1.841q-.231 0-.282-.23l-.77-2.95q-.026-.075-.129-.075H7.397q-.129 0-.129.076l-.744 2.95q-.026.229-.282.229H4.24a.28.28 0 0 1-.206-.077q-.051-.075-.025-.203L8.757 7.229q.05-.23.283-.229h2.413q.23 0 .283.229l4.774 17.293.026.076q0 .204-.257.204zm-6.443-5.29q-.026.025 0 .076a.2.2 0 0 0 .103.026h4.646q.051 0 .077-.026.051-.05.026-.076l-2.388-9.206q-.026-.05-.05-.05-.027 0-.052.05z"
      />
    </svg>
  );
};
SvgCaseNormal.displayName = displayName;
export default SvgCaseNormal;
